export default __webpack_public_path__ + "static/media/favorite-o.947ea932.svg";